export { default as GaugeWidget } from "./gauge_widget";
export { default as WidgetEditGauge } from "./gauge_widget_form";

import * as GaugeWidgetFactory from "./gauge_widget_factory";

export { GaugeWidgetFactory };
